import {createContext, useCallback, useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {formatRelativeTime} from '../utils/calendar';
import {selectProfile, selectUsername} from "./selectors";

export const AppContext = createContext({
    actions: {},
});

export const ServerContext = createContext({});

export const useServerEffect = (func) => {
    const { sse } = useContext(ServerContext);
    sse?.push(func);
};

export const useModal = () => {
    const { modal } = useContext(AppContext);
    return modal;
};

export const useActions = () => {
    const { actions } = useContext(AppContext);
    return actions;
};

export const useSettings = () => {
    return useSelector(selectProfile);
};

export const useLoggedIn = () => {
    return useSelector((state) => Boolean(selectUsername(state)));
};

export const useRelativeTime = (t, full) => {
    const referenceTime = useSelector(({ time }) => time);
    return useMemo(() => formatRelativeTime(t, referenceTime, full), [t, referenceTime, full]);
};

export const useRelativeTimeFormatter = () => {
    const referenceTime = useSelector(({ time }) => time);
    /* eslint-disable react-hooks/exhaustive-deps */
    const cache = useMemo(() => new Map(), [referenceTime]);
    return useCallback((t) => {
        if (!cache.has(t)) {
            cache.set(t, formatRelativeTime(t, referenceTime));
        }
        return cache.get(t);
    }, [referenceTime, cache]);
};
